import React from 'react';
import { Card, Typography, Box } from '@mui/material';

const StatCard = ({
  title,
  value,
  icon,
  color = 'primary',
  bgcolor = '#ffffff'
}) => {
  const getIconColor = (colorName) => {
    const colors = {
      primary: '#667eea',
      secondary: '#f093fb',
      success: '#4facfe',
      warning: '#43e97b',
      info: '#fa709a',
      error: '#ff9a9e',
      dark: '#2d3748',
      grey: '#4a5568'
    };
    return colors[colorName] || colors.primary;
  };

  return (
    <Card
      sx={{
        borderRadius: 1,
        border: '0 solid #fff',
        boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
        transition: 'all 0.2s ease-in-out',
        height: '100%',
        bgcolor: '#ffffff',
        '&:hover': {
          boxShadow: '0 2px 8px 0 rgba(0, 0, 0, 0.1)',
        }
      }}
    >
      <Box sx={{
        p: 3,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 2
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 4, textAlign: 'center' }}>
          {/* Icon */}
          {icon && (
            <Box sx={{
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              p: '0.5rem',
              color: color,
              bgcolor: bgcolor,
              '& svg': {
                width: '1.25rem',
                height: '1.25rem',
              }
            }}>
              {icon}
            </Box>
          )}
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1 }}>
            {/* Title */}
            <Typography
              variant="h6"
              sx={{
                color: '#737373',
                fontSize: '0.875rem',
                lineHeight: '1.25rem',
              }}
            >
              {title}
            </Typography>

            {/* Value */}
            <Typography
              variant="h3"
              component="div"
              sx={{
                fontWeight: 700,
                color: (title === 'Critical Issues' || title === 'Under Review') ? color : '#1f1f1f',
                fontSize: '1.5rem',
                lineHeight: '2rem',
                mb: 0.5
              }}
            >
              {value}
            </Typography>
          </Box>
        </Box>

      </Box>
    </Card>
  );
};

export default StatCard; 